import React from 'react';

import LegalDocumentPage from './LegalDocumentPage';
import termsOfUseContent from './content/termsOfUse';

function TermsOfUse() {
  return <LegalDocumentPage document={termsOfUseContent} />;
}

export default TermsOfUse;
